import {
  myBetsHighlightAction,
  progressBarResetAction,
  progressBarSetAction,
  uiActionsFromSlice,
} from '../reducers/ui';

export const uiActions = {
  ui: uiActionsFromSlice,
  progressBar: {
    set: progressBarSetAction,
    reset: progressBarResetAction,
  },
  myBets: {
    highlight: myBetsHighlightAction,
  },
};
